// src/components/ProductManagement/ProductAddModal.jsx
import React, { useState, useEffect } from 'react';
import { showNotification } from '../../utils/notification';

const ProductAddModal = ({
  isOpen, onClose, onSave, isSaving, categories
}) => {
  const [staging, setStaging] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    categoryId: '',
    description: ''
  });

  // Debug: Log categories when modal opens
  useEffect(() => {
    if (isOpen) {
      console.log('Modal opened - Categories:', categories);
      console.log('Categories length:', categories?.length);
      setStaging([]);
      setFormData({
        name: '',
        categoryId: '',
        description: ''
      });
    }
  }, [isOpen, categories]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const addToStaging = e => {
    e.preventDefault();
    if (!formData.name || !formData.categoryId) {
      showNotification('Please fill all required fields');
      return;
    }

    const newItem = {
      name: formData.name,
      categoryId: parseInt(formData.categoryId),
      description: formData.description
    };

    setStaging(prev => [...prev, newItem]);
    setFormData({
      name: '',
      categoryId: '',
      description: ''
    });
  };

  const removeFromStaging = index => setStaging(prev => prev.filter((_, i) => i !== index));

  const handleSubmit = () => {
    if (staging.length === 0) {
      showNotification('Please add at least one product');
      return;
    }
    onSave({ products: staging });
  };

  const getCategoryText = (id) => {
    const cat = categories?.find(c => c.id == id);
    return cat ? cat.name : id;
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <header className="modal-header">
          <h3>Add Products</h3>
          <button className="close-modal-btn" onClick={onClose} disabled={isSaving}>×</button>
        </header>
        
        <div className="modal-body">
          <form onSubmit={addToStaging} className="modal-form">
            <div className="form-grid-single-column">
              
              <div className="form-row">
                <label htmlFor="product_name">Product Name</label>
                <input 
                  type="text" 
                  id="product_name"
                  name="name" 
                  className="custom-input"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="e.g., Mono Solar Panel 100W"
                  required
                  disabled={isSaving}
                />
              </div>

              <div className="form-row">
                <label htmlFor="product_category">Category</label>
                <select 
                  id="product_category"
                  name="categoryId" 
                  className="custom-select"
                  value={formData.categoryId}
                  onChange={handleChange}
                  required
                  disabled={isSaving}
                >
                  <option value="">Select Category</option>
                  {!categories || categories.length === 0 ? (
                    <option value="" disabled>No categories available</option>
                  ) : (
                    categories.map(cat => (
                      <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))
                  )}
                </select>
                {/* Debug info */}
                {(!categories || categories.length === 0) && (
                  <small style={{ color: 'red' }}>
                    Categories not loaded. Check console for details.
                  </small>
                )}
              </div>

              <div className="form-row">
                <label htmlFor="product_description">Description</label>
                <textarea 
                  id="product_description"
                  name="description" 
                  className="custom-input"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Product description (optional)"
                  rows="3"
                  disabled={isSaving}
                />
              </div>

            </div>
            
            <h4 className="mini-log-title">Batch Log: Products to Add</h4>
            <div className="mini-log-table-container">
              <table className="mini-log-table data-table">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {staging.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center' }}>
                        No products added yet.
                      </td>
                    </tr>
                  ) : (
                    staging.map((item, index) => (
                      <tr key={index}>
                        <td>{item.name}</td>
                        <td>{getCategoryText(item.categoryId)}</td>
                        <td>{item.description || '-'}</td>
                        <td>
                          <button 
                            type="button"
                            className="btn-remove" 
                            onClick={() => removeFromStaging(index)}
                            disabled={isSaving}
                          >
                            X
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>

        <footer className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose} disabled={isSaving}>
            Close
          </button>
          <button 
            className="btn btn-add" 
            onClick={addToStaging}
            disabled={isSaving}
          >
            Add to Batch
          </button>
          <button 
            className="btn btn-print" 
            onClick={handleSubmit}
            disabled={isSaving || staging.length === 0}
          >
            {isSaving ? 'Saving...' : 'Save Batch'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ProductAddModal;